export default "__VITE_ASSET__DmM0DcYF__"